import styled from "@emotion/styled";
import Button from "@mui/material/Button";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import routing from "routing";

import DefaultAuth from "../DefaultAuth";

const Form = styled((props) => {
	const { t } = useTranslation();

	return (
		<div className={props.className}>
			<p>{t("auth.resetPassword.emailSent.subtitle")}</p>
			<Button
				variant="contained"
				fullWidth
				component={Link}
				to={routing.paths.signIn}
			>
				{t("auth.resetPassword.emailSent.backToLogin")}
			</Button>
		</div>
	);
})`
  p {
    color: #49454f;
    font-weight: 500;
    margin: 8px 0;
  }
`;

export default function SuccessResetPassword() {
	const { t } = useTranslation();

	return (
		<DefaultAuth Form={Form} title={t("auth.resetPassword.emailSent.title")} />
	);
}
